<template>
  <div>
    <div class="card">
      <div class="card__header">
        <h2>Export Coupon Report</h2>
      </div>

      <div class="flot-chart-edge">
        <div id="chart-curved-line" class="flot-chart">
          <div class="card__body">
            <div class="export-report form-group">
              <div class="col-md-2">
                <el-select
                  v-model="country"
                  placeholder="Select a country"
                  class="form-control form-control"
                  id="country"
                  name="country"
                  clearable
                >
                  <el-option
                    v-for="item in countries"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
              <div class="col-md-4">
                <el-date-picker
                  v-model="dataRangeValue"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div class="col-md-2">
                <el-select
                  v-model="reportType"
                  placeholder="Select"
                  class="form-control form-control"
                  id="reportType"
                  name="reportType"
                >
                  <el-option
                    v-for="item in reportTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <i class="form-group__bar"></i>
              </div>
              <div class="col-md-2">
                <button class="btn btn-warning" @click="exportReport()">Export Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios, { RepositoryError } from "../../repositories";
import { notify } from "../../utils";

export default {
  mounted() {
    this.getAccessLevel();
  },
  data() {
    return {
      accessLevel: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      country: '',
      countries: [
        {
          value: 'ca',
          label: 'Canada',
        },
        {
          value: 'usa',
          label: 'USA',
        },
      ],
      dataRangeValue: "",
      reportTypes: [
        {
          value: "customerServiceReport",
          label: "Customer Service Report"
        },
        {
          value: "productReport",
          label: "Product Report"
        },
        {
          value: "accountingReport",
          label: "Accounting Report"
        }
      ],
      reportType: ""
    };
  },
  methods: {
    async getAccessLevel() {
      try {
        const res = await axios.get("/discounts/access-level");

        this.accessLevel = res.data.accessLevel;
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }

        throw err;
      }
    },
    async exportReport() {
      try {
        const res = await axios.post("/discounts/export-report", {
          dateRange: this.dataRangeValue,
          reportType: this.reportType,
          country: this.country,
        });

        if (res.data.message) {
          notify(res.data.message, "info");
          return;
        }

        // download related report
        const dateRange = res.data.dateRange;
        const reportType = res.data.reportType;
        const fileName = res.data.fileName;
        const reportFile = res.data.reportFile;

        const csvData = new Blob([reportFile], {
          type: "text/csv;charset=utf-8;"
        });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(csvData, fileName);
          return;
        }

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(csvData);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        
        if (err.response) {
          notify(err.response.data.errors, 'error');
          return;
        }

        throw err;
      }
    }
  }
};
</script>
